import {API_ROOT as DEV_API_ROOT} from './config.dev'
import {API_ROOT as PROD_API_ROOT} from './config.prod'

export const API_ROOT = process.env.NODE_ENV === 'production' ? PROD_API_ROOT : DEV_API_ROOT
export const API_CODE_SUCCESS = 0;
export const API_CODE_USER_NOT_LOGIN = 10006;
export const API_CODE_RECORD_EXISTS = 10004;
export const API_CODE_TASK_SON_EXISTS = 10009;
export const API_CODE_NO_PERMISSION = 10010;
export const API_CODE_USER_NOT_ACTIVE = 10008;

export const CLOSE_TIME = 1.5

export const WORK_WE_CHAT_AGENT_ID = 1000002;
export const WORK_WE_CHAT_APP_ID = 'ww1ab80971fb1d7a0b';
export const WORK_WE_CHAT_CALLBACK_URL = 'https://oa.fancydigital.com.cn/api/login/oauth-callback';
export const WORK_WE_CHAT_STATE = 'https://oa.fancydigital.com.cn';



// WEBPACK FOOTER //
// ./src/config.js